import React from "react";
import { getRetailerInformation } from "../utils/retailer";
import PaymentMethodItem from "./payment-method-item";
export default (props) => {
    const items = props.orderOptions
        .getPaymentOptions()
        .map((o, index) => (React.createElement(PaymentMethodItem, Object.assign({ key: index, paymentOption: o }, props))));
    const retailerInformation = getRetailerInformation(props.orderOptions);
    return (React.createElement("div", { className: "page-main" },
        React.createElement("section", { className: "page-section" },
            React.createElement("h1", { className: "h6" }, "Finansiering"),
            React.createElement("div", { "data-ecom-content": "" },
                React.createElement("p", null, "Hur vill du finansiera din nya bil?"))),
        React.createElement("section", { className: "page-section" },
            React.createElement("div", { "data-ecom-optionlist": "" },
                React.createElement("ul", { className: "option-list" }, items))),
        React.createElement("section", { className: "page-section" },
            React.createElement("div", { "data-ecom-alert": "" },
                React.createElement("div", { className: "alert-icon-section" },
                    React.createElement("div", { className: "alert-icon" },
                        React.createElement("i", { className: "icon-info no-margin" }))),
                React.createElement("div", { className: "alert-content" },
                    "K\u00F6pet \u00E4r villkorat att eventuell finansiering beviljas och att s\u00E4ljare ",
                    retailerInformation.name,
                    " och k\u00F6pare \u00E4r \u00F6verens om pris f\u00F6r eventuell inbytesbil.")))));
};
